import { RawFile } from "@mapmycustomers/shared/types/File";

import { MimesType } from "./mimeTypes";

const hasMimeType = (file: Pick<RawFile, "contentType">, mimeTypes: MimesType[]) =>
  mimeTypes.includes(file.contentType as MimesType);

export * from "./mimeTypes";
export default hasMimeType;
